const base = { width: 44, height: 44, viewBox: "0 0 48 48", fill: "none", stroke: "#B18A4B", strokeWidth: 1.3, strokeLinecap: "round", strokeLinejoin: "round", "aria-hidden": true };

export const WipeIcon = () => (
  <svg {...base} data-testid="icon-wipe">
    <path d="M14 18l14-6 8 16-14 6z" />
    <path d="M18 30c-2 3-2 7 1 10h9c3 0 5-2 5-5v-6" />
    <path d="M22 27v-7M26 26v-8M30 25v-6" />
    <path d="M8 10l2 2M6 16h3M11 6l1 3" />
  </svg>
);

export const BracketIcon = () => (
  <svg {...base} data-testid="icon-bracket">
    <rect x="13" y="8" width="22" height="32" rx="0.8" />
    <path d="M13 8l-4 2v28l4 2M35 8l4 2v28l-4 2" />
    <circle cx="24" cy="24" r="1.6" />
  </svg>
);

export const PlateArrowIcon = () => (
  <svg {...base} data-testid="icon-plate">
    <path d="M26 9l12 4v24l-12 4z" />
    <path d="M6 25h14M16 21l4 4-4 4" />
    <path d="M42 8v34" />
  </svg>
);
